import { useHistory, useLocation } from "react-router-dom";

const LupaPasswordBerhasil = () => {
    const { push } = useHistory();
    const { state } = useLocation();
    const email = state?.email ?? '';

    return (
        <div className='w-100'>
            <p className="fw-bold fs-4 mb-2">Email Terkirim</p>
            <div className='font-sm mb-4'>
                <div className='text-secondary'>
                    Link reset password telah dikirim ke
                </div>
                {email ? (
                    <div className='fw-bold mt-1'>{email}</div>
                ) : null}
                <div className='text-secondary mt-2'>
                    Silakan cek kotak masuk atau folder spam Anda, lalu ikuti instruksi di email tersebut.
                </div>
            </div>
            <div className="d-grid gap-2">
                <button
                    className="btn btn-primary font-sm"
                    type="button"
                    onClick={() => push('/masuk')}
                >
                    Kembali ke Halaman Masuk
                </button>
                <button
                    className="btn btn-outline-primary font-sm"
                    type="button"
                    onClick={() => push('/lupa-password')}
                >
                    Kirim Ulang Email
                </button>
            </div>
        </div>
    );
};

export default LupaPasswordBerhasil;
